import * as React from 'react';
const SvgFileNew = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.208 3.542a2 2 0 0 1 2-2h5.417a.75.75 0 0 1 .75.75v4.166a.5.5 0 0 0 .5.5h4.166a.75.75 0 0 1 .75.75v8.75a2 2 0 0 1-2 2H5.208a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v12.916a.5.5 0 0 0 .5.5h9.583a.5.5 0 0 0 .5-.5v-8h-3.416a2 2 0 0 1-2-2V3.042z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m11.155 1.761 5.417 5.417-1.061 1.06-5.417-5.416z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFileNew;
